import { render, staticRenderFns } from "./Modify.vue?vue&type=template&id=66bbcd9d&scoped=true"
import script from "./Modify.vue?vue&type=script&lang=js"
export * from "./Modify.vue?vue&type=script&lang=js"
import style0 from "./Modify.vue?vue&type=style&index=0&id=66bbcd9d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bbcd9d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shimoyamadayuu/Documents/github/management-site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66bbcd9d')) {
      api.createRecord('66bbcd9d', component.options)
    } else {
      api.reload('66bbcd9d', component.options)
    }
    module.hot.accept("./Modify.vue?vue&type=template&id=66bbcd9d&scoped=true", function () {
      api.rerender('66bbcd9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/function/Modify.vue"
export default component.exports